// redux/selectors/ugc/testimoniesSelectors.ts
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../storeTypes";

const slice = (s: RootState) => s.testimonies;

export const selectSummary = createSelector([slice], (s) => s.summary);
export const selectSummaryStatus = createSelector([slice], (s) => s.summaryStatus);

// بر اساس slug
export const selectDetailBySlug = (slug: string) =>
  createSelector([slice], (s) => s.detail[slug]);

export const selectDetailStatusBySlug = (slug: string) =>
  createSelector([slice], (s) => s.detailStatus[slug] ?? "idle");

// کلیدهای عملیات همچنان رشته‌ای هستند (create:audio | update:video:<slug> ...)
export const selectOpStatus = (key: string) =>
  createSelector([slice], (s) => s.opStatus[key] ?? "idle");

export const selectError = createSelector([slice], (s) => s.error);
